export enum ListFilterOperator {
  equalTo = '=',
  notEqualTo = '!=',
  lessThan = '<',
  lessThanOrEqualTo = '<=',
  greaterThan = '>',
  greaterThanOrEqualTo = '>=',
  contain = '~',
  notContain = '!~',
}
